
<div class="container">
    <div class="row  justify-content-center">
        <div class="box col-12 col-md-8">
            <div class="box__cont">
                <div [ngClass]= '(!searchFormGroup.get("email")?.valid && searchFormGroup.get("email")?.touched) || (!searchFormGroup.get("companyCode")?.valid && searchFormGroup.get("companyCode")?.touched) ? "" : "box__title--otp"' class="box__title">
                    <h1>Forgot Password</h1>
                    <h2>verify your account</h2>
                    <span class="box__error-notif" *ngIf="(!searchFormGroup.get('email')?.valid && searchFormGroup.get('email')?.touched) || (!searchFormGroup.get('companyCode')?.valid && searchFormGroup.get('companyCode')?.touched)">Please fill in all required fields.</span>
                </div>
                <div class="box__form">
                    <div class="col-12 box__field box__field--otp">
                        <div class="col-12 box__field">
                            <atram-textbox [parentFormGroup]="searchFormGroup"
                                            type="text"
                                            controlName="email"
                                            label="Email Address"
                                            placeholder="Email Address"
                                            [number-only]="false"
                                            [isError]="isErrorEmail || (!searchFormGroup.get('email')?.valid && searchFormGroup.get('email')?.touched)"
                                            [isRequired]="true">
                            </atram-textbox>
                        </div>
                        <div class="col-12 box__field">
                            <atram-textbox [parentFormGroup]="searchFormGroup"
                                            type="text"
                                            controlName="companyCode"
                                            label="Company Code"
                                            placeholder="Company Code"
                                            [number-only]="false"
                                            [isError]="isErrorCompanyCode || (!searchFormGroup.get('companyCode')?.valid && searchFormGroup.get('companyCode')?.touched)"
                                            [isRequired]="true">
                            </atram-textbox>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-12">
                            <div class="buttons">
                                <div class="row">
                                    <div class="col-12 col-sm-6 box__hyperlink box__hyperlink--forgot">
                                        <span (click)="goToSignIn()">Sign in Instead</span>
                                    </div>                                 
                                    <div class="col-12 col-sm-6">
                                        <atram-button label="Next"
                                            componentClass="btn-submit"
                                            (on-click)="proceed()">
                                        </atram-button>  
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<atram-modal #atramModal></atram-modal>
